import { render } from "./instaTikTokVerification.vue?vue&type=template&id=6fbcc57f&scoped=true"
import script from "./instaTikTokVerification.vue?vue&type=script&lang=js"
export * from "./instaTikTokVerification.vue?vue&type=script&lang=js"

import "./instaTikTokVerification.vue?vue&type=style&index=0&id=6fbcc57f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbcc57f"]])

export default __exports__